<template>
    <div class="table-row-cells">
        <slot></slot>

        <div v-if="showDaysTillEndOfSubscription" v-indicator="matrix.days_till_end_of_subscription" class="table-td cell-prescription">
            <span v-if="data.days_till_end_of_subscription === null" class="indicator-item">
                <SvgIcon icon="icon-times-circle-big" />
            </span>
            <span v-else-if="data.days_till_end_of_subscription === 0" class="indicator-item">{{ __('Today') }}</span>
            <span v-else-if="data.days_till_end_of_subscription === 1" class="indicator-item">{{ __('Tomorrow') }}</span>
            <span v-else class="indicator-item">{{ __choice('{1} :days d|[2,*] :days d', data.days_till_end_of_subscription, {'days': data.days_till_end_of_subscription}) }}</span>
        </div>

        <div v-show="showProgressCells === 'weight'" class="table-td cell-progress tab-weight">
            <div :style="`width: calc((100%/12)*${Math.min(patient.current_week, 12)}`" class="graph-size">
                <canvas class="weight-progress-graph" height="22" width="225"></canvas>
            </div>
        </div>

        <div v-show="showProgressCells === 'waist'" class="table-td cell-progress tab-waist waist-progress">
            <div :style="`width: calc((100%/12)*${Math.min(patient.current_week, 12)}`" class="graph-size">
                <canvas class="waist-progress-graph" height="22" width="225"></canvas>
            </div>
        </div>

        <div
            v-show="showProgressCells === 'weight'"
            v-indicator="matrix.weight_total_progress"
            class="table-td cell-weight tab-weigh"
        >
            <span v-if="matrix.weight_total_progress" class="indicator-item">
                {{ numberFormat(data.weight_total_progress) }} kg
            </span>

            <span v-else class="indicator-item">0 kg</span>
        </div>

        <div
            v-show="showProgressCells === 'waist'"
            v-indicator="matrix.waist_total_progress"
            class="table-td cell-weight tab-waist"
        >
            <span v-if="matrix.waist_total_progress" class="indicator-item">
                {{ numberFormat(data.waist_total_progress) }} cm
            </span>

            <span v-else class="indicator-item">0 cm</span>
        </div>

        <div class="table-td cell-therapist" @click="showCoachDetailModal">
            <template v-if="patient.my_coach">
                <UserAvatar :user-info="patient.my_coach.user" size="xs" />
                <span>
                    <a data-dismiss="modal" data-target="#modal-therapist" data-toggle="modal" href="#">
                        {{ patient.my_coach.user | fullname }}
                    </a>
                </span>
            </template>
            <template v-else>
                {{ __('The patient hasn\'t connected') }}
            </template>
        </div>
    </div>
</template>

<script>
import PatientRowCells from '@components/PatientsMatrix/PatientRowCells'

export default {
    extends: PatientRowCells,
    mounted() {
        this.initiateGraph('weight_progress')
        this.initiateGraph('waist_progress')
    },
    methods: {
        showCoachDetailModal() {
            Vuemit.fire('Patients--inspect-coach', this.patient.my_coach)
        }
    }
}
</script>
